var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { interpolate } from "./util";
import { API } from "./api";
import { initReporter } from "./util/mdap";
import { CmdToken, delayExec } from "./util/delay-exec";
import { measureTime } from "./util/measure-time";
import pluralRules from "./util/plural-rules";
import IDB from "./indexDB";
import { report } from "./util/mdap";
import { deepClone } from "./util/immutable";
var TSPSDK = /** @class */ (function () {
    /**
     * 构造函数
     * @param options.name - SDK实例名称
     * @param options.isSSR - 是否用于服务端渲染
     *
     */
    function TSPSDK(options) {
        var _this = this;
        if (options === void 0) { options = { name: '' }; }
        /**
         * 该TSPSDK实例的名字
         */
        this.name = '';
        /**
         * 是否用于服务端渲染
         */
        this.isSSR = false;
        /**
         * 从TSP API 获取翻译的超时毫秒数
         * @type {number}
         */
        this.timeout = 3000;
        /**
         * 用于区分live/non-live的TSP API, 默认live
         * @type {string}
         */
        this.env = 'live';
        /**
         *
         * 是否是mainland，用于CDN地址选择
         * @type {boolean}
         */
        this.isMainland = undefined;
        /**
         * 切换语言时用来重新渲染页面
         * @type {function}
         */
        this.forceUpdate = function () { };
        /**
         * 自定义的替换特殊字符
         * @type {function}
         */
        this.replacer = function (content) { return content; };
        /**
         * 存储通过调用 mergeTranslation 方法的翻译数据 形如 {en: {ps_home: 'Home'}}
         * @type {SimpleObject}
         */
        this.commonCache = {};
        /**
         *
         * 当前模块名称 例如 finance
         * @private
         * @type {string}
         */
        this.currentModuleName = '';
        /**
         *
         * 基础模块 例如 framework
         * @private
         * @type {TspModules}
         */
        this.baseModules = {};
        /**
         *
         * 所有业务模块 例如 finance、account
         * @private
         * @type {TspModules}
         */
        this.modules = {};
        /**
         * 所有resource、collection翻译内容的hash值
         */
        this.translationHashes = {};
        this.useCdn = false;
        this.initTimer = null;
        this.initApiCacheUpdateTime = 2 * 60 * 60 * 1000; // 两小时更新一次
        this.timeLimitedGet = function (fn, args) { return __awaiter(_this, void 0, void 0, function () {
            var promises, cdnReq, cdnPromise, apiPromise;
            var _this = this;
            return __generator(this, function (_a) {
                promises = [];
                cdnReq = CmdToken.source();
                if (this.timeout) {
                    cdnPromise = delayExec(function () {
                        // 不带hash，请求的是默认cdn
                        var _args = __assign(__assign({}, args), { hash: '' });
                        return _this.api.getTranslationFromCDN(_args).catch(function () { return ({ headers: {}, body: {} }); });
                    }, this.timeout, cdnReq.token);
                    promises.push(cdnPromise);
                }
                apiPromise = function () { return __awaiter(_this, void 0, void 0, function () {
                    var ret, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, fn(args)];
                            case 1:
                                ret = _a.sent();
                                if (!Object.keys(ret.body).length) {
                                    return [2 /*return*/, cdnReq.execute()];
                                }
                                cdnReq.cancel();
                                return [2 /*return*/, ret];
                            case 2:
                                e_1 = _a.sent();
                                return [2 /*return*/, cdnReq.execute()];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); };
                promises.push(apiPromise());
                return [2 /*return*/, Promise.race(promises)];
            });
        }); };
        if (options) {
            this.name = options.name || '';
            this.isSSR = options.isSSR || false;
        }
        this.api = new API(this.env, false);
        this.idb = new IDB(this.name);
        this.invokeGlobalHook();
        if (this.isSSR && typeof window === 'undefined') {
            this.initTimer && clearInterval(this.initTimer);
            this.initTimer = setInterval(function () {
                _this.updateInitApiCache();
            }, this.initApiCacheUpdateTime);
        }
    }
    /**
     * 初始化TSPSDK
     * @param options.locale - 当前语言类型
     * @param [options.isMainland] - 用于选择CDN地址
     * @param [options.forceUplate] - 切换语言时用来重新渲染页面
     */
    TSPSDK.prototype.create = function (options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var translation, res, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setOptions(options);
                        translation = options.translation;
                        return [4 /*yield*/, this.initRemoteConfig(TSPSDK.locale, translation)];
                    case 1:
                        res = _b.sent();
                        translation = res.formattedMod;
                        if (!(translation && (!res.translation || !Object.keys(res.translation).length))) return [3 /*break*/, 3];
                        _a = res;
                        return [4 /*yield*/, this.initBaseTranslation(translation)];
                    case 2:
                        _a.translation = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (translation && this.hasLazyModules(translation)) {
                            this.initBaseLazyTranslation(translation);
                        }
                        _b.label = 4;
                    case 4:
                        this.exposeTranslator(this);
                        return [2 /*return*/, res];
                }
            });
        });
    };
    TSPSDK.prototype.hasLazyModules = function (mod) {
        return ((mod.lazyResources && !!mod.lazyResources.length)
            || (mod.lazyCollections && !!mod.lazyCollections.length));
    };
    TSPSDK.prototype.formatMod = function (project, mod) {
        if (!project) {
            return mod;
        }
        var result = {};
        if (project.resource_ids && project.resource_ids.length) {
            result.resources = project.resource_ids;
        }
        if (project.collection_ids && project.collection_ids.length) {
            result.collections = project.collection_ids;
        }
        if (project.lazy_resource_ids && project.lazy_resource_ids.length) {
            result.lazyResources = project.lazy_resource_ids;
        }
        if (project.lazy_collection_ids && project.lazy_collection_ids.length) {
            result.lazyCollections = project.lazy_collection_ids;
        }
        if (typeof project.lazy_time === 'number') {
            result.lazyTime = project.lazy_time;
        }
        if (Object.keys(result).length) {
            var _mod = mod || {};
            return __assign(__assign({}, _mod), result);
        }
        return mod;
    };
    TSPSDK.prototype.invokeGlobalHook = function () {
        if (typeof window === 'undefined') {
            return;
        }
        var hooks = window.__tspsdk_global_hooks__;
        if (hooks && typeof hooks === 'object' && typeof hooks.created === 'function') {
            hooks.created(this);
        }
    };
    TSPSDK.prototype.exposeTranslator = function (it) {
        if (typeof window === 'undefined') {
            return;
        }
        if (!window.__tspsdk_translator__) {
            window.__tspsdk_translator__ = [];
        }
        if (window.__tspsdk_translator__.every(function (t) { return t !== it; })) {
            window.__tspsdk_translator__.push(it);
        }
    };
    TSPSDK.prototype.setOptions = function (options) {
        if (options.locale !== undefined) {
            TSPSDK.locale = options.locale;
        }
        if (options.env !== undefined) {
            this.env = options.env;
        }
        if (options.timeout !== undefined) {
            this.timeout = options.timeout;
        }
        this.isMainland = options.isMainland;
        initReporter({
            env: this.env,
            region: options.region,
            name: this.name
        });
        this.api = new API(this.env, !!this.isMainland);
        this.forceUpdate = options.forceUpdate || this.forceUpdate;
        this.replacer = options.replacer || this.replacer;
    };
    TSPSDK.prototype.initRemoteConfig = function (language, mod) {
        var _a;
        if (mod === void 0) { mod = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey, cacheData, data, startTime, indexedDBCache, copyMod_1, translation;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cacheKey = this.getInitApiCacheKey(language, mod);
                        cacheData = this.getInitApiCache(cacheKey);
                        if (!(cacheData && this.isSSR)) return [3 /*break*/, 1];
                        data = cacheData;
                        return [3 /*break*/, 8];
                    case 1:
                        if (!!this.isSSR) return [3 /*break*/, 6];
                        startTime = new Date().getTime();
                        return [4 /*yield*/, this.getIndexedDBCache(cacheKey)];
                    case 2:
                        indexedDBCache = _b.sent();
                        if (!indexedDBCache) return [3 /*break*/, 3];
                        report('f0f5e4863f89fc00ceefc3ad52584fce', new Date().getTime() - startTime);
                        data = indexedDBCache;
                        copyMod_1 = deepClone(mod);
                        setTimeout(function () {
                            _this.fetchInitApi(language, copyMod_1);
                        }, 3000);
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.fetchInitApi(language, mod)];
                    case 4:
                        data = _b.sent();
                        _b.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, this.fetchInitApi(language, mod)];
                    case 7:
                        data = _b.sent();
                        _b.label = 8;
                    case 8:
                        this.translationHashes[language] = data.hashes || {};
                        return [4 /*yield*/, this.setTranslation(language, data.translations)];
                    case 9:
                        translation = _b.sent();
                        if (mod) {
                            mod.name = mod.name || 'base';
                            this.currentModuleName = mod.name;
                            if (data.project) {
                                mod = this.formatMod(data.project, mod);
                            }
                            this.mergeModule(this.baseModules, mod);
                        }
                        this.useCdn = !!+(((_a = data.config) === null || _a === void 0 ? void 0 : _a.use_cdn) || '');
                        return [2 /*return*/, { translation: translation, formattedMod: mod }];
                }
            });
        });
    };
    TSPSDK.prototype.fetchInitApi = function (language, mod) {
        if (mod === void 0) { mod = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var data, cacheKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.init(language, mod)];
                    case 1:
                        data = _a.sent();
                        cacheKey = this.getInitApiCacheKey(language, mod);
                        this.setInitApiCache(cacheKey, data);
                        this.setIndexedDBCache(cacheKey, data);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TSPSDK.prototype.getInitApiCacheKey = function (language, mod) {
        var sortFn = function (a, b) {
            return a - b;
        };
        var projectId = mod.projectId || '';
        var resources = mod.resources || [];
        var collections = mod.collections || [];
        var resourceIds = resources.sort(sortFn).join(',');
        var collectionIds = collections.sort(sortFn).join(',');
        return language + "_p" + projectId + "_r" + resourceIds + "_c" + collectionIds;
    };
    TSPSDK.prototype.getInitApiParamsByCacheKey = function (cacheKey) {
        var language = cacheKey.split('_r')[0];
        var ids = cacheKey.split('_r')[1].split('_c');
        var resources = ids[0] ? ids[0].split(',').map(function (id) { return +id; }) : [];
        var collections = ids[1] ? ids[1].split(',').map(function (id) { return +id; }) : [];
        return { language: language, resources: resources, collections: collections };
    };
    TSPSDK.prototype.setTranslation = function (language, translations) {
        if (translations === void 0) { translations = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var fetchNow, _translation;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetchNow = [];
                        _translation = {};
                        ['resource', 'collection'].forEach(function (key) {
                            var translationSet = translations[key];
                            if (translationSet) {
                                var _loop_1 = function (id, content) {
                                    if (content === 1) {
                                        fetchNow.push(function () { return __awaiter(_this, void 0, void 0, function () {
                                            var res;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, this.getTranslationByType(key, +id, language)];
                                                    case 1:
                                                        res = _a.sent();
                                                        Object.assign(_translation, res);
                                                        return [2 /*return*/, res];
                                                }
                                            });
                                        }); });
                                        return "continue";
                                    }
                                    _this.setCache(key, +id, language, content);
                                    Object.assign(_translation, content);
                                };
                                for (var _i = 0, _a = Object.entries(translationSet); _i < _a.length; _i++) {
                                    var _b = _a[_i], id = _b[0], content = _b[1];
                                    _loop_1(id, content);
                                }
                            }
                        });
                        if (!fetchNow.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(fetchNow.map(function (fn) { return fn(); }))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, _translation];
                }
            });
        });
    };
    TSPSDK.prototype.initBaseTranslation = function (mod) {
        return this.loadTranslation(mod);
    };
    TSPSDK.prototype.initBaseLazyTranslation = function (mod) {
        return this.getLazyTranslationByModule(TSPSDK.locale, mod);
    };
    /**
     * 获取当前的模块信息
     */
    TSPSDK.prototype.getCurrentModule = function () {
        return this.modules[this.currentModuleName];
    };
    /**
     * 返回TSPSDK中存储的所有模块信息
     */
    TSPSDK.prototype.getAllModules = function () {
        return __assign(__assign({}, this.baseModules), this.modules);
    };
    /**
     * 切换语言，并拉取相关的翻译数据
     * moduleNames: 例如['listing', 'drc']
     * @param {string} locale
     * @param {string[]} [moduleNames]
     */
    TSPSDK.prototype.switchLanguage = function (locale, moduleNames) {
        return __awaiter(this, void 0, void 0, function () {
            var allModules, requiedModules, baseModules, translations;
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        allModules = this.getAllModules();
                        requiedModules = {};
                        if (moduleNames) {
                            moduleNames.map(function (name) {
                                requiedModules[name] = allModules[name];
                            });
                            requiedModules = __assign(__assign({}, this.baseModules), requiedModules);
                        }
                        baseModules = this.baseModules[Object.keys(this.baseModules)[0]];
                        return [4 /*yield*/, this.initRemoteConfig(locale, baseModules)];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.getTranslationByModules(locale, moduleNames ? requiedModules : allModules)];
                    case 2:
                        translations = _b.sent();
                        TSPSDK.locale = locale;
                        if (this.forceUpdate && typeof this.forceUpdate === 'function') {
                            setTimeout(function () {
                                _this.forceUpdate();
                            }, 0);
                        }
                        return [2 /*return*/, (_a = Object.assign).call.apply(_a, __spreadArrays([null, {}], translations))];
                }
            });
        });
    };
    /**
     * 切换模块，并拉取相关的翻译数据
     */
    TSPSDK.prototype.switchModule = function (module) {
        if (typeof module === 'string') {
            if (!this.getAllModules()[module]) {
                throw new Error('module not found');
            }
            this.currentModuleName = module;
            module = this.getAllModules()[module];
        }
        else {
            if (!module.name) {
                throw new Error('module must have a name');
            }
            this.currentModuleName = module.name;
        }
        return this.getTranslationByModule(TSPSDK.locale, module);
    };
    /**
     * use mergeTranslation instead
     * @deprecated
     */
    TSPSDK.prototype.mergeLocale = function (locale, message) {
        return this.mergeTranslation(message, locale);
    };
    /**
     * 合并额外的翻译数据
     */
    TSPSDK.prototype.mergeTranslation = function (translation, locale) {
        if (locale === void 0) { locale = TSPSDK.locale; }
        this.commonCache[locale] = this.commonCache[locale] || {};
        for (var k in translation) {
            if (Object.prototype.hasOwnProperty.call(translation, k)) {
                this.commonCache[locale][k] = translation[k];
            }
        }
        // this.commonCache[locale] = {...this.commonCache[locale], ...message};
    };
    /**
     * 建议使用 $t
     * 返回单复数形式的key的翻译字符串
     * @deprecated
     */
    TSPSDK.prototype.$tc2 = function (key, count, values) {
        return this.$t(key, count, values);
    };
    /**
     * 返回翻译字符串
     */
    TSPSDK.prototype.$t = function (key, count, values) {
        var result = this._$t(key, count, values);
        return result && typeof result === 'string' ? result : key;
    };
    /**
     * 用于i18n组件
     */
    TSPSDK.prototype.$i = function (key, values) {
        // count = '_' 仅为了区分非数字与非空的情况
        return this._$t(key, '_', values, 'raw') || key;
    };
    /**
     * 返回翻译字符串
     */
    TSPSDK.prototype._$t = function (key, count, values, mode) {
        count = Number(count) || count; // 兼容count传了字符串类型的数字. 如: $t('ps_', '1')
        if (values) {
            count = count || 0; // 解决没有传count, 但是传了values的情况. 如: $t('ps_', undefined, {count: 1})
        }
        if (count !== null && typeof count === 'object') {
            values = count; // 当只传了两个参数，那么第二个参数应该是values
        }
        var content = this.findTranslationByKey(key);
        if (typeof count === 'number') {
            var cat = (pluralRules[TSPSDK.locale] || pluralRules.en)(count);
            // 复数第一种模式
            // plural_key: { one: '', other: '', zero: '' }
            if (typeof content === 'object') {
                return this.__$t(content[cat] || content.one || content.other, values, mode);
            }
            // 复数第二种模式
            // plural_key__one: '',
            // plural_key__other: '',
            // plural_key__zero: ''
            var findOrder = this.pluralFindOrder(cat);
            for (var _i = 0, findOrder_1 = findOrder; _i < findOrder_1.length; _i++) {
                var _cat = findOrder_1[_i];
                var findKey = key + "__" + _cat;
                var foundContent = this.findTranslationByKey(findKey);
                var result = this.__$t(foundContent, values, mode);
                if (result && findKey !== result) {
                    return result;
                }
            }
        }
        return this.__$t(content, values, mode);
    };
    TSPSDK.prototype.pluralFindOrder = function (cat) {
        if (cat === 'one') {
            return ['one', 'other'];
        }
        if (cat === 'other') {
            return ['other', 'one'];
        }
        return [cat, 'one', 'other'];
    };
    /**
     * 处理翻译内容
     */
    TSPSDK.prototype.__$t = function (content, values, mode) {
        if (typeof content === 'object' || !content) {
            return content;
        }
        var result = content;
        if (this.replacer) {
            try {
                result = this.replacer(result);
            }
            catch (e) {
                // console.error('TSPSDK replacer error: ', e);
            }
        }
        return values ? interpolate(result, values, mode) : result;
    };
    /**
     * 获取某个resource或collection的特定key的翻译数据
     * @param {string} keys [如果多个key，以逗号分隔]
     */
    TSPSDK.prototype.getTranslationByKeys = function (locale, type, id, keys) {
        return this.getTranslationByType(type, id, locale, keys);
    };
    /**
     * @private 拉取多个模块的翻译
     * @param {string} locale
     * @param {TspModules} modules
     * @returns Promise
     */
    TSPSDK.prototype.getTranslationByModules = function (locale, modules) {
        var _this = this;
        var promises = Object.keys(modules).map(function (name) {
            return _this.getTranslationByModule(locale, _this.getAllModules()[name]);
        });
        return Promise.all(promises);
    };
    /**
     * 拉取一个模块的翻译
     * 推荐使用loadTranslation
     * @deprecated
     */
    TSPSDK.prototype.getTranslationByModule = function (locale, module) {
        return __awaiter(this, void 0, void 0, function () {
            var resources, collections, lazyResources, lazyCollections, lazyTime, promises, res;
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!module) {
                            // console.error('TSPSDK.getTranslationByModule has no module');
                            return [2 /*return*/, {}];
                        }
                        module.name = module.name || 'mod_' + Date.now();
                        this.mergeModule(this.modules, module);
                        resources = module.resources, collections = module.collections, lazyResources = module.lazyResources, lazyCollections = module.lazyCollections, lazyTime = module.lazyTime;
                        promises = [];
                        if (collections === null || collections === void 0 ? void 0 : collections.length) {
                            promises.push.apply(promises, collections.map(function (id) { return _this.getTranslationByType('collection', id, locale); }));
                        }
                        if (resources === null || resources === void 0 ? void 0 : resources.length) {
                            promises.push.apply(promises, resources.map(function (id) { return _this.getTranslationByType('resource', id, locale); }));
                        }
                        if (lazyResources && lazyResources.length) {
                            setTimeout(function () {
                                lazyResources === null || lazyResources === void 0 ? void 0 : lazyResources.forEach(function (id) { return _this.getTranslationByType('resource', id, locale); });
                            }, lazyTime || 3000);
                        }
                        if (lazyCollections && lazyCollections.length) {
                            setTimeout(function () {
                                lazyCollections === null || lazyCollections === void 0 ? void 0 : lazyCollections.map(function (id) { return _this.getTranslationByType('collection', id, locale); });
                            }, lazyTime || 3000);
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        res = _b.sent();
                        return [2 /*return*/, (_a = Object.assign).call.apply(_a, __spreadArrays([null, {}], res))];
                }
            });
        });
    };
    /**
     * 拉取模块的lazy翻译
     */
    TSPSDK.prototype.getLazyTranslationByModule = function (locale, module) {
        return __awaiter(this, void 0, void 0, function () {
            var lazyResources, lazyCollections, lazyTime;
            var _this = this;
            return __generator(this, function (_a) {
                if (!module) {
                    return [2 /*return*/, {}];
                }
                module.name = module.name || 'mod_' + Date.now();
                lazyResources = module.lazyResources, lazyCollections = module.lazyCollections, lazyTime = module.lazyTime;
                if (lazyResources && lazyResources.length) {
                    setTimeout(function () {
                        lazyResources === null || lazyResources === void 0 ? void 0 : lazyResources.forEach(function (id) { return _this.getTranslationByType('resource', id, locale); });
                    }, lazyTime || 3000);
                }
                if (lazyCollections && lazyCollections.length) {
                    setTimeout(function () {
                        lazyCollections === null || lazyCollections === void 0 ? void 0 : lazyCollections.map(function (id) { return _this.getTranslationByType('collection', id, locale); });
                    }, lazyTime || 3000);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * 根据当前的语言拉取更多的翻译数据
     * @param mod
     * @param locale 如果想拉取其他语言的翻译，可以指定对于的语言
     */
    TSPSDK.prototype.loadTranslation = function (mod, locale) {
        return this.getTranslationByModule(locale || TSPSDK.locale, mod);
    };
    /**
     * 根据传入的resource和collection id列表拉取翻译
     * @deprecated
     */
    TSPSDK.prototype.getTranslations = function (locale, mod) {
        return this.getTranslationByModule(locale, mod);
    };
    TSPSDK.prototype.getTranslationByType = function (type, id, language, keys) {
        return __awaiter(this, void 0, void 0, function () {
            var cache, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cache = this.getCache(type, id, language);
                        if (cache) {
                            return [2 /*return*/, cache];
                        }
                        return [4 /*yield*/, this.fetchTranslation(type, id, language, keys)];
                    case 1:
                        body = (_a.sent()).body;
                        if (keys) {
                            this.mergeTranslation(body, language);
                        }
                        else {
                            this.setCache(type, id, language, body);
                        }
                        return [2 /*return*/, body];
                }
            });
        });
    };
    TSPSDK.prototype.fetchTranslation = function (type, id, language, keys) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var hash, fn;
            return __generator(this, function (_c) {
                hash = (_b = (_a = this.translationHashes[language]) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b[id];
                fn = this.useCdn ? this.api.getTranslationFromCDN : this.api.getTranslationFromAPI;
                return [2 /*return*/, this.timeLimitedGet(fn, { type: type, id: id, language: language, hash: hash, keys: keys })];
            });
        });
    };
    TSPSDK.prototype.getCacheKey = function (id, locale) {
        return id + '_' + locale.toLowerCase();
    };
    TSPSDK.prototype.setCache = function (type, id, locale, message) {
        var cache = type === 'resource' ? TSPSDK.resourceCache : TSPSDK.collectionCache;
        var key = this.getCacheKey(id, locale); // for example: 52en
        cache[key] = cache[key] || {};
        cache[key] = __assign(__assign({}, cache[key]), message);
    };
    TSPSDK.prototype.getCache = function (type, id, locale) {
        var cache = type === 'resource' ? TSPSDK.resourceCache : TSPSDK.collectionCache;
        var key = this.getCacheKey(id, locale); // for example: 52en
        return cache[key];
    };
    TSPSDK.prototype.setIndexedDBCache = function (key, content) {
        if (!this.isSSR && content && Object.keys(content).length > 0) {
            this.idb.set(key, content);
        }
    };
    TSPSDK.prototype.getIndexedDBCache = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var indexedDBCacheData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.isSSR) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.idb.get(key)];
                    case 1:
                        indexedDBCacheData = _a.sent();
                        return [2 /*return*/, indexedDBCacheData || null];
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    TSPSDK.prototype.setInitApiCache = function (key, data) {
        return TSPSDK.initApiCache[key] = data;
    };
    TSPSDK.prototype.getInitApiCache = function (key) {
        return TSPSDK.initApiCache[key];
    };
    TSPSDK.prototype.updateInitApiCache = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKeys, promises;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!TSPSDK.initApiCache) return [3 /*break*/, 2];
                        cacheKeys = Object.keys(TSPSDK.initApiCache);
                        promises = cacheKeys.map(function (cacheKey) { return __awaiter(_this, void 0, void 0, function () {
                            var _a, language, resources, collections;
                            var _this = this;
                            return __generator(this, function (_b) {
                                _a = this.getInitApiParamsByCacheKey(cacheKey), language = _a.language, resources = _a.resources, collections = _a.collections;
                                return [2 /*return*/, this.api.init(language, { resources: resources, collections: collections }).then(function (res) {
                                        _this.setInitApiCache(cacheKey, res);
                                    })];
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TSPSDK.prototype.findTranslationByKey = function (key) {
        var result = '';
        var currentModule = this.getCurrentModule();
        if (currentModule) {
            result = this.findTranslationFromModule(key, currentModule);
            if (result) {
                return result;
            }
        }
        var baseModuleNames = Object.keys(this.baseModules);
        for (var i = 0; i < baseModuleNames.length; i++) {
            var name_1 = baseModuleNames[i];
            result = this.findTranslationFromModule(key, this.baseModules[name_1]);
            if (result) {
                return result;
            }
        }
        result = this.findTranslationFromCommon(key);
        if (result) {
            return result;
        }
        var allModules = this.getAllModules();
        var allModuleNames = Object.keys(allModules);
        for (var i = 0; i < allModuleNames.length; i++) {
            var name_2 = allModuleNames[i];
            result = this.findTranslationFromModule(key, allModules[name_2]);
            if (result) {
                return result;
            }
        }
        return result || '';
    };
    TSPSDK.prototype.findTranslationFromModule = function (key, module) {
        var collections = (module.collections || []).concat(module.lazyCollections || []);
        var resources = (module.resources || []).concat(module.lazyResources || []);
        for (var i = 0; i < collections.length; i++) {
            var cache = this.getCache('collection', collections[i], TSPSDK.locale);
            if (cache && cache[key]) {
                return cache[key];
            }
        }
        for (var i = 0; i < resources.length; i++) {
            var cache = this.getCache('resource', resources[i], TSPSDK.locale);
            if (cache && cache[key]) {
                return cache[key];
            }
        }
        return '';
    };
    TSPSDK.prototype.findTranslationFromCommon = function (key) {
        var cache = this.commonCache[TSPSDK.locale];
        if (cache && cache[key]) {
            return cache[key];
        }
        return '';
    };
    TSPSDK.prototype.mergeModule = function (modules, module) {
        var current = modules[module.name + ''];
        if (!current) {
            modules[module.name + ''] = module;
            return;
        }
        current.collections = current.collections || [];
        current.resources = current.resources || [];
        module.collections = module.collections || [];
        module.resources = module.resources || [];
        module.collections.map(function (id) {
            var _a;
            if (((_a = current.collections) === null || _a === void 0 ? void 0 : _a.indexOf(id)) === -1) {
                current.collections.push(id);
            }
        });
        module.resources.map(function (id) {
            var _a;
            if (((_a = current.resources) === null || _a === void 0 ? void 0 : _a.indexOf(id)) === -1) {
                current.resources.push(id);
            }
        });
    };
    TSPSDK.version = '0.2.7';
    /**
     * 当前的语言类型
     */
    TSPSDK.locale = 'en';
    /**
     * 按resource id + locale存储翻译数据 形如 {52en: {ps_home: 'Home'}}
     * @type {ResourceCache}
     */
    TSPSDK.resourceCache = {};
    /**
     *
     * 按collection id + locale存储翻译数据 形如 {33en: {ps_home: 'Home'}}
     * @type {ResourceCache}
     */
    TSPSDK.collectionCache = {};
    /**
     *
     * 按collection id + locale存储翻译数据 形如 {33en: {ps_home: 'Home'}}
     * @type {ResourceCache}
     */
    TSPSDK.initApiCache = {};
    __decorate([
        measureTime('66434261232b824496e0a6569d107c83')
    ], TSPSDK.prototype, "create", null);
    __decorate([
        measureTime('2abb8903b113cbe3b812775bbb3d7654')
    ], TSPSDK.prototype, "initRemoteConfig", null);
    __decorate([
        measureTime('f7d982865e455c53251a928695cf8ba4')
    ], TSPSDK.prototype, "setTranslation", null);
    __decorate([
        measureTime('59d11e7cc0a156483eb9bff150e31046')
    ], TSPSDK.prototype, "initBaseTranslation", null);
    __decorate([
        measureTime('eb066b904c4b0717fd91463a102b41cf')
    ], TSPSDK.prototype, "initBaseLazyTranslation", null);
    return TSPSDK;
}());
export default TSPSDK;
//# sourceMappingURL=sdk.js.map